import React from 'react';
import { ErrorScreen } from './ErrorScreen';

export class ErrorBoundary extends React.Component {
  static getDerivedStateFromError(error) {
    console.error(error);
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = {
      bannerProps: {
        description: <>Please reload to access the application</>,
        title: 'Something went wrong',
      },
      hasError: false,
    };
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErrorScreen bannerProps={this.state.bannerProps} />;
    }
    return this.props.children;
  }
}
